import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import classNames from "classnames";
import { ChartOfAccountsRow } from "../utils";
import styles from "../styles.module.scss";

export const AccountSubtypeCell = memo(
    ({ row }: CellContext<ViewTableFeatures, ChartOfAccountsRow, string>) => {
        const rowData = row.original;

        // Classification row - no subtype
        if (rowData.classification) {
            return <ViewTableCell />;
        }

        // Account row
        if (rowData.account) {
            return (
                <ViewTableCell>
                    <div
                        className={classNames(
                            styles.columnContent,
                            styles.subtypeColumn,
                        )}
                    >
                        {rowData.account.subtype}
                    </div>
                </ViewTableCell>
            );
        }

        return <ViewTableCell />;
    },
);
